import React, { useMemo } from 'react';
import {
  Label,
  FormGroup,
} from 'reactstrap';

import FieldError from '../../../../../helper/FieldError';

import Select from 'react-select';

const LaboralBulkLoadAraucoDocxMergeFieldFormItem = (props) => {
  const {
    associatedMergeField,
    data,
    callbacks,
    errors
  } = props;

  const {
    headers,
    systemOptions
  } = data;

  const {
    onChangeAssociatedMergeFieldCallback
  } = callbacks;

  const onChangeAssociatedMergeField = event => {
    onChangeAssociatedMergeFieldCallback(associatedMergeField.mergeField, event.value);
  }

  const selectOptions = useMemo(() => {
    const headerOptions = _.map(headers, header => {
      return { label: header, value: header }
    });
    const mergedOptions = [...headerOptions, ...systemOptions.map(o => ({ label: o.label, value: o.key }))];

    return mergedOptions;
  }, [headers, systemOptions])

  const selectedOption = useMemo(() => {
    return _.find(selectOptions, { value: associatedMergeField.header })
  }, [associatedMergeField.header])

  return (
    <tr>
      <td>
        <Label>{associatedMergeField.mergeField}</Label>
      </td>
      <td>
        <FormGroup>
          <FieldError errors={_.get(errors, `associated_merge_fields_${associatedMergeField.mergeField}`) || []}>
            <Select
              options={selectOptions}
              value={selectedOption}
              onChange={event => onChangeAssociatedMergeField(event)}
              invalid={_.has(errors, `associated_merge_fields_${associatedMergeField.mergeField}`)}
              placeholder='- Seleccione una opción -'
              isClearable
            />

            {/* <Input
              type='select'
              value={ associatedMergeField.header }
              onChange={ event => onChangeAssociatedMergeField(event)}
              invalid={ _.has(errors, `associated_merge_fields_${associatedMergeField.mergeField}`) }
            >
              <option value="">- Seleccione una opción -</option>
              { _.map(headers, header => {
                return(
                  <option
                    key={ `option-${ associatedMergeField.mergeField }-${ header }` }
                    value={ header }
                  >
                    { header }
                  </option>
                )
              }) }
            </Input> */}
          </FieldError>
        </FormGroup>
      </td>
    </tr>
  )
}

export default React.memo(LaboralBulkLoadAraucoDocxMergeFieldFormItem);
